/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { STORAGE_KEYS } from './../../constants';
import { GlobalActions, GlobalStates } from './global.models';

const initialState: GlobalStates = {
  activeMatchHistoryView: 'all',
  activeStatsView: undefined,
  activeTimeframe: 'all-time',
  banner: undefined,
  notification: undefined,
  selectedProvider: undefined,
  sourceIdMap: undefined,
};

export const useGlobalStore = create<GlobalActions & GlobalStates>()(
  persist(
    (set) => ({
      ...initialState,
      setActiveView: (update) => {
        set((state) => ({ ...state, ...update }));
      },
      setBanner: (banner) => {
        set({ banner });
      },
      setNotification: (notification) => {
        set({ notification });
      },
      setSelectedProvider: (selectedProvider) => {
        set({ selectedProvider });
      },
      setSourceIdMap: (sourceIdMap) => {
        set({ sourceIdMap });
      },
    }),
    {
      name: STORAGE_KEYS['GLOBAL_SESSION_STORE'],
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        activeMatchHistoryView: state.activeMatchHistoryView,
        activeStatsView: state.activeStatsView,
        activeTimeframe: state.activeTimeframe,
        selectedProvider: state.selectedProvider,
      }),
    },
  ),
);
